var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCleverLive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "CleverLive_svg__b",
    xmlns: "http://www.w3.org/2000/svg",
    width: 171.63,
    height: 171.96,
    viewBox: "0 0 171.63 171.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".CleverLive_svg__d{fill:#181c37}.CleverLive_svg__e{fill:#07aca8}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CleverLive_svg__c"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "CleverLive_svg__e",
    points: "14.23 43.42 0 29.19 0 0 29.6 0 43.42 13.83 14.23 13.83 14.23 43.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CleverLive_svg__e",
    points: "14.23 128.54 0 142.78 0 171.96 29.6 171.96 43.42 158.14 14.23 158.14 14.23 128.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CleverLive_svg__e",
    points: "157.39 43.42 171.63 29.19 171.63 0 142.03 0 128.2 13.83 157.39 13.83 157.39 43.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CleverLive_svg__e",
    points: "157.39 128.54 171.63 142.78 171.63 171.96 142.03 171.96 128.2 158.14 157.39 158.14 157.39 128.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CleverLive_svg__d",
    d: "m69.82,65.45c-2.47,0-4.65.48-6.55,1.44-1.9.96-3.5,2.33-4.79,4.12-1.29,1.79-2.27,3.97-2.93,6.53-.67,2.57-1,5.45-1,8.63s.3,6.13.89,8.66c.6,2.52,1.51,4.65,2.75,6.39,1.23,1.73,2.82,3.05,4.74,3.95,1.93.9,4.22,1.35,6.89,1.35,2.47,0,4.95-.28,7.43-.83s5.18-1.35,8.09-2.37v10.82c-1.33.56-2.65,1.03-3.95,1.41-1.3.39-2.64.71-3.99.96-1.36.25-2.75.44-4.18.56-1.43.12-2.96.19-4.6.19-4.69,0-8.75-.75-12.19-2.25-3.44-1.5-6.28-3.61-8.53-6.33-2.25-2.72-3.91-5.99-4.99-9.82-1.08-3.83-1.62-8.09-1.62-12.78s.62-8.83,1.87-12.67c1.25-3.84,3.08-7.15,5.49-9.92,2.41-2.77,5.4-4.93,8.95-6.47,3.55-1.54,7.63-2.31,12.23-2.31,3.02,0,6.05.38,9.09,1.14,3.04.76,5.94,1.81,8.72,3.14l-4.16,10.49c-2.27-1.08-4.56-2.02-6.87-2.83-2.3-.81-4.56-1.21-6.78-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CleverLive_svg__d",
    d: "m95.32,116.42v-60.84h12.9v50.19h22.14v10.65h-35.04Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleverLive);
export default __webpack_public_path__ + "static/media/CleverLive.faf2038a2abfd1a851cb652758b93cd9.svg";
export { ForwardRef as ReactComponent };